import type { ReactNode } from "react";
import styles from "./DetailRow.module.scss";

/** A label/value row for detail cards, with an optional trailing actions slot. */
export function DetailRow({
  label,
  children,
  actions,
  grid = false,
}: {
  label: ReactNode;
  children: ReactNode;
  /** Small buttons acting on exactly this row's state, stacked. */
  actions?: ReactNode;
  /**
   * Three fixed columns (label · value · actions) so values and buttons line
   * up across rows. Column widths come from `--detail-label-w` and
   * `--detail-actions-w` on an ancestor.
   */
  grid?: boolean;
}) {
  return (
    <div className={grid ? `${styles.detailRow} ${styles.grid}` : styles.detailRow}>
      <span className={styles.detailLabel}>{label}</span>
      <span className={styles.detailValue}>{children}</span>
      {(actions != null || grid) && <span className={styles.detailActions}>{actions}</span>}
    </div>
  );
}
